export default __webpack_public_path__ + "static/media/send_image.54265664.png";